import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, props } from '@ngrx/store';
import { WorkflowArea } from '../enums/workflow-area.enum';
import { SubjectType } from '../enums/subject-type.enum';
import { GetTasksOfProjectDto } from '../dtos/getTasksOfProjectDto';

export const SyncActions = createActionGroup({
    source: 'CPMM Sync',
    events: {
        'Sync Project Workflow': props<{ 
            projectId: string; 
            workflowArea: WorkflowArea; 
            sync: boolean;
            // REV-22155 — PERSON: `/person-projects/:id/sync`
            subjectType?: SubjectType;
        }>(),
        'Project Workflow Synced': props<{ response: GetTasksOfProjectDto }>(),
        'Project Workflow Sync Failure': props<{ error: HttpErrorResponse }>(),
    },
}); 